import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';

const TestMailDialog = ({ open, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <CheckCircleIcon color="success" style={{fontSize:"40px"}} />
          Success
        </Typography>
        {/* <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton> */}
      </DialogTitle>

      <DialogContent>
        <Typography variant='subtitle2'>Email configuration works. Test email sent successfully.</Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="contained" sx={{backgroundColor:"#8e9194"}}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TestMailDialog;
